import React from 'react';
import type { WorksheetVisualKind } from '../../data/content';
import { WorksheetVisual } from './WorksheetVisual';
type WorksheetPreviewProps = {
  band: string;
  level: string;
  title: string;
  visual: WorksheetVisualKind;
  header: string;
};
export function WorksheetPreview({
  band,
  level,
  title,
  visual,
  header
}: WorksheetPreviewProps) {
  return <div className="mx-auto flex aspect-[3/4] w-full max-w-sm flex-col overflow-hidden rounded-lg bg-white text-navy shadow-[0_10px_30px_-12px_rgba(0,0,0,0.5)]" data-id="element-271" data-mp="1b4gl21dizlfz">
      <div className={`flex items-center justify-between px-4 py-2.5 text-white ${header}`} data-id="element-272" data-mp="ieq4llof87gp">
        <span className="font-display text-[11px] font-extrabold uppercase tracking-wide" data-id="element-273" data-mp="nbqc810x5i9x">
          MATHE BEREIT™ · {band}
        </span>
        <span className="text-[10px] font-semibold opacity-90" data-id="element-274" data-mp="s9rtqhip59ja">{level.split(' · ')[0]}</span>
      </div>
      <div className="flex flex-1 flex-col px-4 pb-4 pt-3 sm:px-5" data-id="element-275" data-mp="1yu156nlf0oqu">
        <div className="flex items-center justify-between border-b border-slate-200 pb-2 text-[9px] text-navy/50" data-id="element-276" data-mp="23pq6owgzwfps">
          <span data-id="element-277" data-mp="1uiaphx4b9cpj">Name: ____________</span>
          <span data-id="element-278" data-mp="1qhrw3ymrryl8">Datum: ________</span>
        </div>
        <p className="mt-3 font-display text-base font-extrabold leading-tight sm:text-lg" data-id="element-279" data-mp="1qi087ob2izvd">{title}</p>
        <div className="mt-3 flex min-h-0 flex-1 items-center justify-center rounded-lg bg-ice/60 p-2.5" data-id="element-280" data-mp="1lgkmrv4zarcg">
          <WorksheetVisual kind={visual} data-id="element-281" data-mp="1gj2kgnlgvadf" />
        </div>
        <div className="mt-3 space-y-2" aria-hidden="true" data-id="element-282" data-mp="1bkhl0qe1guq1">
          <div className="flex items-center gap-2" data-id="element-283" data-mp="1bm2jus7dyztp">
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-navy text-[8px] font-bold text-white" data-id="element-284" data-mp="16spswbf8igxs">1</span>
            <span className="h-px flex-1 bg-slate-300" data-id="element-285" data-mp="12ptj9a7o9v5z" />
          </div>
          <div className="flex items-center gap-2" data-id="element-286" data-mp="xu4bwkpev9z4">
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-navy text-[8px] font-bold text-white" data-id="element-287" data-mp="stgpydg1hjbr">2</span>
            <span className="h-px flex-1 bg-slate-300" data-id="element-288" data-mp="nvonwqlokgtu" />
          </div>
        </div>
        <p className="mt-3 text-right text-[9px] font-semibold text-navy/50" data-id="element-289" data-mp="e6rs0g1fre7h">Lösungen im Anhang ✓</p>
      </div>
    </div>;
}